import React, { useState } from "react";

const MalayalamMonthFinder = () => {
  const [selectedDate, setSelectedDate] = useState("");
  const [malayalamMonth, setMalayalamMonth] = useState("");

  const getMalayalamMonth = (day, month) => {
    if ((month === 8 && day >= 17) || (month === 9 && day <= 16)) return "Chingam";
    if ((month === 9 && day >= 17) || (month === 10 && day <= 16)) return "Kanni";
    if ((month === 10 && day >= 17) || (month === 11 && day <= 15)) return "Thulam";
    if ((month === 11 && day >= 16) || (month === 12 && day <= 15)) return "Vrischikam";
    if ((month === 12 && day >= 16) || (month === 1 && day <= 14)) return "Dhanu";
    if ((month === 1 && day >= 15) || (month === 2 && day <= 12)) return "Makaram";
    if ((month === 2 && day >= 13) || (month === 3 && day <= 14)) return "Kumbham";
    if ((month === 3 && day >= 15) || (month === 4 && day <= 13)) return "Meenam";
    if ((month === 4 && day >= 14) || (month === 5 && day <= 14)) return "Medam";
    if ((month === 5 && day >= 15) || (month === 6 && day <= 14)) return "Edavam";
    if ((month === 6 && day >= 15) || (month === 7 && day <= 16)) return "Mithunam";
    if ((month === 7 && day >= 17) || (month === 8 && day <= 16)) return "Karkidakam";
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    setSelectedDate(value);

    if (value) {
      const date = new Date(value);
      const day = date.getDate();
      const month = date.getMonth() + 1;

      const malMonth = getMalayalamMonth(day, month);
      setMalayalamMonth(malMonth);
    } else {
      setMalayalamMonth("");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h3>Select Date</h3>

      <input
        type="date"
        value={selectedDate}
        onChange={handleDateChange}
      />

      {malayalamMonth && (
        <p style={{ marginTop: "10px", fontWeight: "bold" }}>
          Malayalam Month: {malayalamMonth}
        </p>
      )}
    </div>
  );
};

export default MalayalamMonthFinder;